import React, { useState } from "react";
import LoginForm from "./Login_page";
import RegisterPage from "./Register_page";
import "./Register_Login_page.css"
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TrackOrder from "./Track_order";
import StickyComponent from "./Sticky_component";

function RegisterLoginpage() {
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('token')) !== null) {
      navigate('/my-account/address');
    }
  }, [])

  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>
      {
        (showMessage) ?
          <div className={`register-login-notification ${error ? 'error' : ''}`}>
            <p>{message}</p>
          </div>
          : null
      }
      <div>
        <h5 className="register-login-header-text">If you a registered user then please login otherwise register yourself here.</h5>
        <div className="register-login-constainer">
          <div className="login-container">
            <LoginForm setShowMessage={setShowMessage} setMessage={setMessage} setError={setError} />
          </div>
          <div>
            <RegisterPage setShowMessage={setShowMessage} setMessage={setMessage} setError={setError} />
          </div>
        </div>
        {/* <TrackOrder/> */}
      </div>

      <About_p />
      <Footer />

      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }
      <StickyComponent />
    </>
  )
};

export default RegisterLoginpage